import { Controller } from "@hotwired/stimulus"

// Keeps the planning card's "N of M responses" caption truthful when the
// target is changed from the detail modal sitting over it.
//
// MissionsController#update_target_responses responds with a turbo_stream
// replacing two ids: mission_<id>_target_responses (the modal's editable cell)
// and mission_<id>_stats (the card's progress tile). This caption is neither
// of those -- it is planning-side markup outside the tile -- so without this
// the card would go on displaying the old target the moment after the user
// typed a new one.
//
// That endpoint and its turbo_stream are shared and unmodified; this listens
// for the stream rather than changing what it sends. The new value is read out
// of the incoming cell's own number field rather than scraped from its text,
// so a wording change there can't silently break this.
export default class extends Controller {
  static values = { missionId: Number }

  connect() {
    this.onStream = this.handleStream.bind(this)
    document.addEventListener("turbo:before-stream-render", this.onStream)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.onStream)
  }

  handleStream(event) {
    const stream = event.detail?.newStream
    if (!stream) return
    if (stream.getAttribute("target") !== `mission_${this.missionIdValue}_target_responses`) return

    const incoming = stream.querySelector("template")?.content
    if (!incoming) return

    const field = incoming.querySelector('input[name="mission[target_responses_count]"]')
    const target = field ? field.value : null

    // Applied on the next frame so this runs after the stream has landed.
    requestAnimationFrame(() => this.applyTarget(target))
  }

  applyTarget(target) {
    const slot = this.element.querySelector("[data-planning-target-sync-slot]")
    if (!slot) return

    const parsed = parseInt(target, 10)
    if (Number.isNaN(parsed) || parsed <= 0) {
      slot.textContent = "no target"
      return
    }
    slot.textContent = String(parsed)
  }
}
